import { ReactNode, useMemo } from 'react';
import { useCurrentUser, useAllowedModules } from '../../../shared/auth/AuthProvider';
import { resolveEffectiveTurnoGeoModules } from '../../../shared/config/turnoGeoModules';
import { Header, EmptyState } from '../../../shared/components';

/**
 * Version de RequireModule para TurnoGeo (ver shared/components/RequireModule.tsx
 * para el equivalente de Control Operativo y modules/human-resources/components/RequireHr.tsx
 * para Gestion Humana). Se mantiene separado a proposito: cada aplicacion
 * resuelve sus pantallas efectivas contra su PROPIO catalogo - el Rol es por
 * aplicacion, no global.
 */
export function RequireTurnoGeoModule({ moduleId, children }: { moduleId: string; children: ReactNode }) {
  const user = useCurrentUser();
  const allowedModules = useAllowedModules();
  const effective = useMemo(() => resolveEffectiveTurnoGeoModules(user.role, allowedModules), [user.role, allowedModules]);

  if (!effective.includes(moduleId)) {
    return (
      <div>
        <Header title="Acceso restringido" />
        <div className="p-4">
          <EmptyState icon="🔒" title="No tienes acceso a este módulo" description="Si necesitas usarlo, pide a un administrador que te lo habilite desde Configuración > Usuarios de TurnoGeo." />
        </div>
      </div>
    );
  }
  return <>{children}</>;
}

/** Version de RequireAdmin para TurnoGeo - Supervisor y Operador de ESTA aplicacion nunca pasan. */
export function RequireTurnoGeoAdmin({ children }: { children: ReactNode }) {
  const user = useCurrentUser();

  if (user.role !== 'admin') {
    return (
      <div>
        <Header title="Acceso restringido" />
        <div className="p-4">
          <EmptyState icon="🔒" title="Solo para administradores" description="Configuración administra sedes, parámetros, catálogo de modalidad y usuarios de TurnoGeo - es exclusiva del rol Administrador de esta aplicación." />
        </div>
      </div>
    );
  }
  return <>{children}</>;
}

/** Admin y supervisor (líderes) de ESTA aplicación; el operador nunca ve las horas acumuladas. */
export function RequireTurnoGeoLeader({ children }: { children: ReactNode }) {
  const user = useCurrentUser();
  if (user.role !== 'admin' && user.role !== 'supervisor') {
    return (
      <div>
        <Header title="Acceso restringido" />
        <div className="p-4">
          <EmptyState icon="🔒" title="Solo para líderes" description="El reporte de horas y recargos es para administradores y supervisores de TurnoGeo." />
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
